import { useLazyQuery } from "@apollo/client";
import React, { useEffect, useRef, useState } from "react";
import Button from "../Button/Button";
import { AdditionalConfig } from "./ConfigObject";
import { ErrorToast } from "../ToastComponent/RectHotToast";

const ApiButtonInput = ({
  InputConfig,
  inputRef,
  placeholder,
  name,
  onChange,
  label,
  isRequired = false,
  buttonLabel = "Go",
  RowId,
  dispatch,
  formkey,
  onBlur,
  onFocus,
  value
}) => {
  console.log(InputConfig);
  let masterName = InputConfig?.masterName;
  let queryName = AdditionalConfig[masterName]?.dropdowndata;
  let variable = InputConfig?.variable ? InputConfig?.variable : {};
  const [GetDropData, { loading: dropdownLoading }] = useLazyQuery(queryName, {
    variables: {
      keyword: value || "",
      ...variable,
    },
    fetchPolicy: "network-only",
  });

  const HandleApicallButoon = () => {
    console.log(InputConfig.header, "InputConfig.header");
    if (value) {
      GetDropData({
        variables: {
          keyword: value || "",
        },
        fetchPolicy: "network-only",
        context: {
          headers: InputConfig.header ? InputConfig.header : "",
        },
      }).then((res) => {
        const data = res?.data;
        console.log(data);
        let responseData = data && Object.values(data)[0];
        handleError(responseData);
        if (Array.isArray(responseData)) {
          responseData = responseData[0];
        } else if (typeof responseData === "object" && responseData !== null) {
          responseData = responseData;
        }
        dispatch({
          type: RowId ? "StoreMasterDataForRow" : "StoreMasterData",
          payload: {
            formkey,
            rowId: RowId,
            data: { [name]: responseData || {} },
          },
        });
      });
    }
  };
  return (
    <div className={`form__group field apiButtonInput`}>
      <input
        id={InputConfig.id}
        ref={inputRef}
        autoComplete="off"
        placeholder={placeholder}
        className="form__field"
        type="text"
        name={name}
        value={value}
        onChange={onChange}
        style={{ flex: 1 }}
        onBlur={onBlur}
        onFocus={onFocus}
      />
      <label className="form__label textAreaLabel" style={{ marginTop: "1px" }}>
        {label || name}
        {isRequired && <span className="required_label"> *</span>}
      </label>
      <div className="api-button-container">
        <Button
          type="button"
          className="api-button"
          text={buttonLabel}
          name="api-button"
          action={HandleApicallButoon}
          loadingState={dropdownLoading}
          disabled={inputRef?.current?.disabled}
        />
      </div>
    </div>
  );
};

export default ApiButtonInput;

function handleError(responseData) {
  // Check for null
  if (responseData === null) {
    ErrorToast("Data Not Found");
    return;
  }

  // Check if it's an array and empty
  if (Array.isArray(responseData) && responseData.length === 0) {
    ErrorToast("Data Not Found");
    return;
  }

  // Check if it's an object and empty
  if (typeof responseData === "object" && !Array.isArray(responseData) && Object.keys(responseData).length === 0) {
    ErrorToast("Data Not Found");
    return;
  }
}
